import { createInjectionKey as o } from "./ghl-ui.es896.js";
const n = o("n-config-provider");
export {
  n as configProviderInjectionKey
};
